/* eslint-disable */
import $ from 'jquery';

(function($, window, document, undefined){
  var blnIsTouchDevice = !!('ontouchstart' in window) || !!(navigator.msMaxTouchPoints);

  $(document).ready(function(){
    if (blnIsTouchDevice) {
      $('.site-settings-item').on('click.SiteSetting', function () {
        $(this).siblings('.is--open').removeClass('is--open');
        $(this).toggleClass('is--open');

        // close several other flyouts
        // $('.page-header .search').removeClass('is--open');
        // $('.page-header .meta-main-navigation .btn').removeClass('is--active');
        // $('.main-navigation').removeClass('is--open');
        // $('body').removeClass('open-off-canvas');
      });
    }
  });
})($, window, document);



// WEBPACK FOOTER //
// ./assets/js/components/site-settings.js